import React from "react"
import Select, {StylesConfig} from "react-select"
import {countries} from "../../../resources/countries"

interface CountryOption {
	readonly value: string
	readonly label: string
}

const countryOptions: CountryOption[] = Object.entries(countries).map(([code, name]) => ({
	value: code,
	label: name,
}))

const selectStyles: StylesConfig<CountryOption, true> = {
	control: (base, state) => ({
		...base,
		borderColor: state.isFocused ? "#000000" : base.borderColor,
		"&:hover": {
			borderColor: state.isFocused ? "#000000" : base.borderColor,
		},
		minHeight: 52,
		marginTop: 8,
	}),
	container: (base) => ({
		...base,
		width: "100%",
	}),
}

interface CountriesOfOperationFormFieldProps {
	value: string[] | undefined
	onChange: (value: string[] | undefined) => void
}

export default function CountriesOfOperationFormField({value, onChange}: CountriesOfOperationFormFieldProps) {
	const handleSelectChange = (newValue: readonly CountryOption[]) => {
		if (newValue.length === 0) {
			onChange(undefined)
		} else {
			onChange(newValue.map((v) => v.value))
		}
	}

	const selectedOptions = countryOptions.filter((o) => value?.includes(o.value))

	return (
		<div className="double-column-field countries-of-operation-field">
			<label className="label-text" htmlFor="countriesOfOperation">
				Countries of Operation
			</label>
			<Select<CountryOption, true>
				id="countriesOfOperation"
				isMulti
				value={selectedOptions}
				options={countryOptions}
				onChange={handleSelectChange}
				styles={selectStyles}
				placeholder="Select countries..."
				closeMenuOnSelect={false}
				hideSelectedOptions={false}
				menuPlacement="auto"
			/>
		</div>
	)
}
